import React from "react";

const Education = () => {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M26.775 13.6525C26.9988 13.5537 27.1887 13.3915 27.3212 13.186C27.4537 12.9804 27.5229 12.7404 27.5204 12.4959C27.5179 12.2513 27.4436 12.0129 27.3069 11.8101C27.1702 11.6073 26.977 11.449 26.7512 11.355L16.0375 6.47496C15.7118 6.32639 15.358 6.24951 15 6.24951C14.642 6.24951 14.2882 6.32639 13.9625 6.47496L3.24999 11.35C3.02745 11.4474 2.83814 11.6076 2.7052 11.811C2.57226 12.0143 2.50146 12.252 2.50146 12.495C2.50146 12.7379 2.57226 12.9756 2.7052 13.1789C2.83814 13.3823 3.02745 13.5425 3.24999 13.64L13.9625 18.525C14.2882 18.6735 14.642 18.7504 15 18.7504C15.358 18.7504 15.7118 18.6735 16.0375 18.525L26.775 13.6525Z"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M27.5 12.5V20"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.5 15.625V20C7.5 20.9946 8.29018 21.9484 9.6967 22.6517C11.1032 23.3549 13.0109 23.75 15 23.75C16.9891 23.75 18.8968 23.3549 20.3033 22.6517C21.7098 21.9484 22.5 20.9946 22.5 20V15.625"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default Education;
